export const smpRoutes = [

        { path:'smp/dept-manage',name:'Smp-Dept-Manage',
            component: resolve => require(['@/views/smp/org/department/DepartmentManage.vue'], resolve),props:true,
            meta:{compPath:'/smp/org/department/DepartmentManage.vue'} 
        }, 
        { path:'smp/person-manage',name:'Smp-Person-Manage',
            component: resolve => require(['@/views/smp/org/person/PersonManage.vue'], resolve),props:true, 
            meta:{compPath:'/smp/org/person/PersonManage.vue'} 
        }, 

        { path:'smp/module-manage',name:'Smp-Module-Manage',
            component: resolve => require(['@/views/smp/sys/module/ModuleManage.vue'], resolve),props:true,
            meta:{compPath:'/smp/sys/module/ModuleManage.vue'}
        },
        { path:'smp/module-function-manage',name:'Smp-Module-Function-Manage',
            component: resolve => require(['@/views/smp/sys/module/ModuleFunctionManage.vue'], resolve),props:true,
            meta:{compPath:'/smp/sys/module/ModuleFunctionManage.vue'}
         },
        { path:'smp/app-manage',name:'Smp-App-Manage',
            component: resolve => require(['@/views/smp/sys/app/AppManage.vue'], resolve),props:true,
            meta:{compPath:'/smp/sys/app/AppManage.vue'}
        },    
        { path:'smp/menu-manage',name:'Smp-Menu-Manage',
            component: resolve => require(['@/views/smp/sys/app/MenuManage.vue'], resolve),props:true,
            meta:{compPath:'/smp/sys/app/MenuManage.vue'}
        }, 
        { path:'smp/oper-group-manage',name:'Smp-Oper-Group-Manage',
            component: resolve => require(['@/views/smp/sys/auth/OperGroupManage.vue'], resolve),props:true,
            meta:{compPath:'/smp/sys/auth/OperGroupManage.vue'}
        }, 
        { path:'smp/oper-auth-manage',name:'Smp-Oper-Auth-Manage',
            component: resolve => require(['@/views/smp/sys/auth/OperAuthManage.vue'], resolve),props:true,
            meta:{compPath:'/smp/sys/auth/OperAuthManage.vue'}
        },     
                 
    ]
; 